import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { Row } from "reactstrap";
import { Col } from "reactstrap";
import GameOverModal from "../../../components/GameOverModal";
import GameWonModal from "../../../components/GameWonModal";
import { useFinishedGame } from "../../../components/gameXpFunction";
import { useDarkMode } from "../../../context/DarkModeProvider";
import "../../../assets/css/gamesCss/List/singlyLinkedIntro.css";
import "../../../assets/css/colors.css";
import { useLanguage } from "context/LanguageProvider";
import { init } from "i18next";




const SinglyLinkedListIntro = () => {

    const { selLanguage, toggleLanguage, isLoading } = useLanguage();
    const [chosenQuestion, setChosenQuestions] = useState([]);

    const questions = [
        {
            id: 1,
            text: selLanguage
                ? "Η σύνδεση στις singly linked lists είναι _____ και η περιήγηση γίνεται από την αρχή προς το τέλος."
                : "The connection in singly linked lists is _____ and traversal goes from the beginning to the end.",
            answer: selLanguage ? "μονοκατευθυντική" : "unidirectional",
            options: selLanguage
                ? ["αμφίδρομη", "μονοκατευθυντική", "κυκλική", "διπλή"]
                : ["bidirectional", "unidirectional", "circular", "double"]
        },
        {
            id: 2,
            text: selLanguage
                ? "Η χρονική πολυπλοκότητα εισαγωγής στοιχείου αμέσως μετά από γνωστό κόμβο είναι _____."
                : "The time complexity of inserting an element right after a known node is _____.",
            answer: "O(1)",
            options: ["O(n)", "O(log n)", "O(1)", "O(n²)"]
        },
        {
            id: 3,
            text: selLanguage
                ? "Στις singly linked lists δεν υπάρχει δείκτης προς _____ κόμβο."
                : "In singly linked lists, there is no pointer to the _____ node.",
            answer: selLanguage ? "προηγούμενο" : "previous",
            options: selLanguage
                ? ["επόμενο", "τελευταίο", "κεντρικό", "προηγούμενο"]
                : ["next", "last", "middle", "previous"]
        },
        {
            id: 4,
            text: selLanguage
                ? "Η χρονική πολυπλοκότητα για πρόσβαση σε συγκεκριμένη θέση είναι _____ γιατί πρέπει να διασχίσουμε τους κόμβους διαδοχικά."
                : "The time complexity for accessing a specific position is _____ because we must traverse the nodes sequentially.",
            answer: "O(n)",
            options: ["O(n)", "O(1)", "O(log n)", "O(n²)"]
        },
        {
            id: 5,
            text: selLanguage
                ? "Η δέσμευση μνήμης γίνεται μόνο όσο χρειάζεται για κάθε νέο στοιχείο, αποφεύγοντας τη _____ μνήμης."
                : "Memory is allocated only as needed for each new element, avoiding memory _____.",
            answer: selLanguage ? "σπατάλη" : "waste",
            options: selLanguage
                ? ["δέσμευση", "σπατάλη", "διαχείριση", "κατανομή"]
                : ["allocation", "waste", "management", "distribution"]
        },
        {
            id: 6,
            text: selLanguage
                ? "Η λίστα μπορεί να αυξομειώνεται _____ κατά την εκτέλεση του προγράμματος."
                : "The list can grow or shrink _____ during program execution.",
            answer: selLanguage ? "δυναμικά" : "dynamically",
            options: selLanguage
                ? ["στατικά", "δυναμικά", "σταθερά", "αυτόματα"]
                : ["statically", "dynamically", "fixed", "automatically"]
        },
        {
            id: 7,
            text: selLanguage
                ? "Δεν μπορεί να γίνει άμεση _____ προσπέλαση σε οποιοδήποτε στοιχείο της λίστας."
                : "There cannot be direct _____ access to any element of the list.",
            answer: selLanguage ? "τυχαία" : "random",
            options: selLanguage
                ? ["σειριακή", "διαδοχική", "γραμμική", "τυχαία"]
                : ["sequential", "successive", "linear", "random"]
        },
        {
            id: 8,
            text: selLanguage
                ? "Οι singly linked lists χρησιμοποιούνται σε συστήματα διαχείρισης μνήμης και σε μηχανισμούς _____ μνήμης."
                : "Singly linked lists are used in memory management systems and in memory _____ mechanisms.",
            answer: selLanguage ? "διαμοιρασμού" : "sharing",
            options: selLanguage
                ? ["κατανομής", "απελευθέρωσης", "διαμοιρασμού", "δέσμευσης"]
                : ["allocation", "release", "sharing", "reservation"]
        },
        {
            id: 9,
            text: selLanguage
                ? "Η εστίαση των singly linked lists είναι σε λειτουργίες εισαγωγής/διαγραφής, εις βάρος της ταχύτητας προσπέλασης _____ στοιχείων."
                : "Singly linked lists focus on insertion/deletion performance at the cost of slower access to _____ elements.",
            answer: selLanguage ? "αυθαίρετων" : "arbitrary",
            options: selLanguage
                ? ["αυθαίρετων", "διαδοχικών", "συγκεκριμένων", "τυχαίων"]
                : ["arbitrary", "successive", "specific", "random"]
        },
        {
            id: 10,
            text: selLanguage
                ? "Κάθε κόμβος περιέχει μια αναφορά _____ προς τον επόμενο κόμβο της λίστας."
                : "Each node contains a reference _____ to the next node in the list.",
            answer: selLanguage ? "αποκλειστικά" : "exclusively",
            options: selLanguage
                ? ["προαιρετικά", "αποκλειστικά", "δυνητικά", "συνήθως"]
                : ["optionally", "exclusively", "potentially", "usually"]
        }
    ];

    const { handleGameComplete, isProcessing } = useFinishedGame();
    const { darkMode } = useDarkMode();
    const gameCompletedRef = useRef(false);

    const selectedStage = JSON.parse(localStorage.getItem("selectedStage"));
    var games = selectedStage.games;
    var nameGameKey = localStorage.getItem("gameClicked");
    var selectedGame = null;
    for (let i = 0; i < games.length; i++) {
        if (games[i].game_title === nameGameKey) {
            selectedGame = games[i];
            break;
        }
    }

    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [userAnswer, setUserAnswer] = useState("");
    const [feedback, setFeedback] = useState(null);
    const [lives, setLives] = useState(3);
    const [showGameOver, setShowGameOver] = useState(false);
    const [showGameWon, setShowGameWon] = useState(false);
    const [score, setScore] = useState(0);
    const [timeLeft, setTimeLeft] = useState(12);
    const [askedQuestions, setAskedQuestions] = useState([]);

    const timeoutRef = useRef(null);



    useEffect(() => {
        if (lives <= 0) {
            setShowGameOver(true);
        }
    }, [lives]);

    useEffect(() => {
        if (currentQuestion >= questions.length && !showGameOver) {
            setShowGameWon(true);
        }
        // Check if all questions have been asked
        if (askedQuestions.length >= questions.length && !showGameOver) {
            setShowGameWon(true);
        }
    }, [currentQuestion, showGameOver, askedQuestions]);

    // Timer effect
    useEffect(() => {
        if (feedback) return; // Don't countdown during feedback

        setTimeLeft(12); // Reset timer for new question

        const timer = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    // Time's up - lose a life
                    setFeedback({
                        success: false,
                        message: selLanguage ? `Τελείωσε ο χρόνος! Η σωστή απάντηση είναι: ${questions[currentQuestion].answer}` : `Time's up! The correct answer is: ${questions[currentQuestion].answer}`
                    });
                    setLives(lives - 1);
                    if (timeoutRef.current) {
                        clearTimeout(timeoutRef.current);
                    }

                    timeoutRef.current = setTimeout(() => {
                        setAskedQuestions((prev) => {
                            const availableQuestions = questions
                                .map((_, index) => index)
                                .filter((index) => !prev.includes(index));

                            if (availableQuestions.length > 0) {
                                const randomIndex =
                                    availableQuestions[Math.floor(Math.random() * availableQuestions.length)];
                                setCurrentQuestion(randomIndex);
                                return [...prev, randomIndex];
                            }

                            return prev;
                        });


                        setUserAnswer("");
                        setFeedback(null);
                    }, 2000);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [currentQuestion, feedback, lives, askedQuestions]);

    const handleSubmit = () => {
        const correct = questions[currentQuestion].answer.toLowerCase();
        const user = userAnswer.trim().toLowerCase();

        // Στο handleSubmit - και για σωστή απάντηση:
        if (user === correct) {
            setFeedback({ success: true, message: "Σωστά!" });
            setScore(score + 1);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            timeoutRef.current = setTimeout(() => {
                setAskedQuestions((prev) => {
                    const availableQuestions = questions
                        .map((_, index) => index)
                        .filter((index) => !prev.includes(index));

                    if (availableQuestions.length > 0) {
                        const randomIndex =
                            availableQuestions[Math.floor(Math.random() * availableQuestions.length)];
                        setCurrentQuestion(randomIndex);
                        return [...prev, randomIndex];
                    }

                    return prev;
                });

                setUserAnswer("");
                setFeedback(null);
            }, 1500);


        } else {
            setFeedback({ success: false, message: selLanguage ? `Λάθος! Η σωστή απάντηση είναι: ${questions[currentQuestion].answer}` : `Wrong! The correct answer is: ${questions[currentQuestion].answer}` });
            setLives(lives - 1);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            timeoutRef.current = setTimeout(() => {
                const availableQuestions = questions
                    .map((_, index) => index)
                    .filter(index => !askedQuestions.includes(index));

                if (availableQuestions.length > 0) {
                    const randomIndex = availableQuestions[Math.floor(Math.random() * availableQuestions.length)];
                    setCurrentQuestion(randomIndex);
                    setAskedQuestions([...askedQuestions, randomIndex]);
                }

                setUserAnswer("");
                setFeedback(null);
            }, 2000);
        }
    };

    const handleOptionClick = (option) => {
        setUserAnswer(option);
    };

    const resetGame = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }

        setCurrentQuestion(0);
        setUserAnswer("");
        setFeedback(null);
        setLives(3);
        setScore(0);
        setShowGameOver(false);
        setShowGameWon(false);
        setTimeLeft(12);
        setAskedQuestions([]);
    };





    if (showGameOver || showGameWon) {
        return (
            <div className='main-content' style={{
                minHeight: "90vh",
                background: darkMode
                    ? "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #101724ff 100%)"
                    : "var(--lightModeBack)",
                padding: "30px 10px",
                borderRadius: "10px",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                overflowX: "hidden"
            }}>
                <GameOverModal isVisible={showGameOver} onPlayAgain={resetGame} />
                <GameWonModal isVisible={showGameWon} onPlayAgain={resetGame} />
            </div>
        );
    }

    return (
        <div
            className='main-content singlyIntroContainer'
            style={{
                background: darkMode ? "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #101724ff 100%)" : "var(--lightModeGameBackground)"
            }}
        >
            <Col xl="12" lg="12" md="12" sm="12" xs="12">
                <div className="max-w-7xl mx-auto">

                    {/* Lives Display */}
                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                        <div style={{
                            color: darkMode ? "white" : "#1e293b",
                            padding: "12px 24px",
                            borderRadius: "12px",
                            fontWeight: "700",
                            fontSize: "18px",
                            border: darkMode ? "2px solid white" : "2px solid #1e293b",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px"
                        }}>
                            {selLanguage ? "Ερώτηση" : "Question"} {askedQuestions.length + 1}/{questions.length}
                        </div>

                        {/* Timer Display */}
                        <div style={{
                            background: timeLeft <= 3
                                ? "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)"
                                : "linear-gradient(135deg, #1037b9ff 0%, #050f96ff 100%)",
                            padding: "8px 20px",
                            borderRadius: "12px",
                            color: "white",
                            fontWeight: "700",
                            fontSize: "18px",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                            transition: "all 0.3s ease",
                            animation: timeLeft <= 3 ? "pulse 0.5s ease-in-out infinite" : "none"
                        }}>
                            {timeLeft}s
                        </div>

                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "row",
                            justifyContent: "right",
                            gap: "12px"
                        }}>

                            <div style={{
                                display: "flex",
                                gap: "6px",
                                alignItems: "center"
                            }}>
                                {[1, 2, 3].map((heartNum) => (
                                    <div
                                        key={heartNum}
                                        style={{
                                            fontSize: "24px",
                                            filter: lives >= heartNum
                                                ? "drop-shadow(0 4px 8px rgba(220, 38, 38, 0.4))"
                                                : "grayscale(100%) opacity(0.3)",
                                            transform: lives >= heartNum ? "scale(1)" : "scale(0.8)",
                                            transition: "all 0.3s ease",
                                            animation: lives >= heartNum ? "heartbeat 2s ease-in-out infinite" : "none"
                                        }}
                                    >
                                        ❤️
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <style>{`
                        @keyframes heartbeat {
                            0%, 100% { transform: scale(1); }
                            50% { transform: scale(1.1); }
                        }
                        @keyframes pulse {
                            0%, 100% { transform: scale(1); opacity: 1; }
                            50% { transform: scale(1.05); opacity: 0.9; }
                        }
                    `}</style>

                    {/* Instructions */}
                    <div className="singlyIntroProm">
                        {selLanguage ? "Επέλεξε τη σωστή επιλογή για κάθε πρόταση. Στόχος είναι να ολοκληρώσεις όλες τις ερωτήσεις χωρίς να χάσεις όλες τις ζωές σου" : "Select the correct option for each sentence. The goal is to complete all the questions without losing all your lives."}
                    </div>

                    {/* Main Game Frame */}
                    <div className="singlyIntroFrame">
                        {/* Question Text */}
                        <div style={{
                            fontSize: "1.2rem",
                            fontWeight: "600",
                            color: "#1f2937",
                            textAlign: "center",
                            marginBottom: "30px",
                            lineHeight: "1.6",
                            padding: "0 10px"
                        }}>
                            {questions[currentQuestion].text}
                        </div>

                        {/* Input Field */}
                        <input
                            className="singlyIntroInput"
                            type="text"
                            value={userAnswer}
                            onChange={(e) => setUserAnswer(e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' && userAnswer.trim() && handleSubmit()}
                            placeholder={selLanguage ? "Γράψε την απάντηση..." : "Type the answer..."}

                        />

                        {/* Options */}
                        <div style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "10px",

                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            padding: "0 10px"
                        }}>
                            {questions[currentQuestion].options.map((option, idx) => (
                                <motion.button
                                    key={idx}
                                    onClick={() => handleOptionClick(option)}
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                        background: userAnswer === option
                                            ? "linear-gradient(135deg, #f97316 0%, #ea580c 100%)"
                                            : "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                                        color: "#ffffff",
                                        fontWeight: "700",
                                        fontSize: "0.9rem",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        cursor: "pointer",
                                        border: "2px solid rgba(245, 245, 245, 0.5)",
                                        userSelect: "none",
                                        transition: "all 0.3s ease"
                                    }}
                                >
                                    {idx + 1}
                                </motion.button>
                            ))}
                        </div>

                        {/* Option Labels */}
                        <div style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(2, 1fr)",
                            gap: "8px",
                            width: "90%",
                            maxWidth: "500px",
                            marginTop: "15px",
                            fontSize: "17px"
                        }}>
                            {questions[currentQuestion].options.map((option, idx) => (
                                <div key={idx} style={{
                                    color: "#1f2937",
                                    fontWeight: "500",
                                    textAlign: "center",
                                    padding: "4px"
                                }}>
                                    {idx + 1}. {option}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div style={{ textAlign: "center", display: "flex", justifyContent: "center", width: "100%", gap: "12px" }}>
                        <button
                            onClick={handleSubmit}
                            disabled={!userAnswer.trim()}
                            style={{
                                background: !userAnswer.trim()
                                    ? "linear-gradient(135deg, #64748b 0%, #475569 100%)"
                                    : "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                                color: "white",
                                border: "none",
                                borderRadius: "16px",
                                padding: "14px 28px",
                                fontSize: "1rem",
                                fontWeight: 600,
                                cursor: !userAnswer.trim() ? "not-allowed" : "pointer",
                                boxShadow: "0 10px 25px rgba(59, 130, 246, 0.3)",
                                transition: "all 0.3s ease",
                                transform: "scale(1)"
                            }}
                            onMouseEnter={(e) => {
                                if (userAnswer.trim()) {
                                    e.target.style.transform = "scale(1.02)";
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (userAnswer.trim()) {
                                    e.target.style.transform = "scale(1)";
                                }
                            }}
                        >
                            {selLanguage ? "Υποβολή Απάντησης" : "Submit"}
                        </button>

                        <button
                            onClick={resetGame}
                            className="singlyIntroResetButton"
                            onMouseEnter={(e) => {
                                e.target.style.transform = "scale(1.02)";
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = "scale(1)";
                            }}
                        >
                            {selLanguage ? "Επανεκκίνηση" : "Restart"}
                        </button>
                    </div>

                    {/* Feedback */}
                    {feedback && (
                        <motion.div
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            style={{
                                textAlign: "center",
                                padding: "20px",
                                borderRadius: "16px",
                                marginTop: "20px",
                                background: feedback.success
                                    ? "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)"
                                    : "linear-gradient(135deg, #fef2f2 0%, #fecaca 100%)",
                                border: `2px solid ${feedback.success ? "#10b981" : "#ef4444"}`,
                                color: feedback.success ? "#059669" : "#dc2626",
                                fontWeight: 600,
                                fontSize: "1rem",
                                boxShadow: feedback.success
                                    ? "0 10px 25px rgba(16, 185, 129, 0.2)"
                                    : "0 10px 25px rgba(239, 68, 68, 0.2)"
                            }}
                        >
                            {feedback.message}
                        </motion.div>
                    )}
                </div>
            </Col>
        </div>
    );
};

export default SinglyLinkedListIntro;